import { Observable } from 'rxjs';
import { ValidAuthentication } from '@/app/platform/platform-core/user/services/types';
import { InjectionToken } from '@angular/core';

export const AUTHENTICATION_OBSERVABLE_FACTORY = new InjectionToken<AuthenticationObservableFactory>(
  ''
);

export interface AuthenticationObservableFactory {
  create(): Observable<ValidAuthentication>;
}
